import { dateStamp } from '../../../lib/championships.js'
import styles from './DateStamp.module.css'

/**
 * The "we hunted this date down" stamp.
 *
 * Brian: "Next to any championship you have officially hunted down with
 * official date, I want there to be a stamp on it."
 *
 * ⚠️ IT DECIDES NOTHING. `dateStamp()` in lib/championships.js is the whole
 * rule and it is asserted by verify-datestamp.mjs; this file only draws what it
 * returns. A second copy of "is this date real?" living in a component is how
 * the board and the model start disagreeing, and the entire value of a stamp is
 * that it is never wrong.
 *
 * ⚠️ NULL IS THE COMMON CASE. Roughly nine records in ten carry a projected
 * date and get NOTHING drawn — the stamp means something because it is rare.
 */
export default function DateStamp({ c, compact = false }) {
  const s = dateStamp(c)
  if (!s) return null
  const cls = s.kind === 'sourced' ? styles.sourced : styles.unsourced
  return (
    <span className={`${styles.stamp} ${cls} ${compact ? styles.compact : ''}`} title={s.title}>
      {s.kind === 'sourced' && <span className={styles.tick} aria-hidden="true">✓</span>}
      {s.label}
    </span>
  )
}
